<template>
  <v-dialog
    :model-value="paymentDialog"
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <!-- <v-card elevation="2">
      <v-row
        align="center"
        justify="center"
        :style="{ height: `${VuetifyObj.height}px` }"
        no-gutters
      >
        <v-col cols="12" class="text-center">
          <v-icon
            class="mb-5"
            color="success"
            icon="mdi-check-circle"
            size="112"
          ></v-icon>

          <v-card>
            <v-card-text>
              <v-img
                :width="500"
                aspect-ratio="16/9"
                cover
                eager
                lazy-src
                :src="payment_details.qr_code_url"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card> -->
    <v-container fluid class="d-flex justify-center align-center fill-height">
      <v-card
        :width="400"
        class="pa-4"
        elevation="4"
        style="border-radius: 16px"
      >
        <!-- Title -->
        <div class="text-center mb-4">
          <h3 class="text-h6 font-weight-medium">Scan to Pay</h3>
          <p class="text-caption grey--text">
            {{ payment_details.banking_name }}
          </p>
          <p class="text-caption grey--text">{{ payment_details.upi_id }}</p>
        </div>

        <!-- QR IMAGE -->
        <div class="d-flex justify-center">
          <v-img
            width="200"
            height="300"
            eager
            lazy-src
            :src="payment_details.qr_code_url"
            class="rounded"
          ></v-img>
        </div>

        <!-- Buttons -->
        <div class="text-center mt-4">
          <v-btn color="primary" class="mr-2" @click="paymentDialogEmit">
            close
          </v-btn>
        </div>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    paymentDialog: Boolean,
    VuetifyObj: Object,
    payment_details: Object,
  },
  methods: {
    paymentDialogEmit() {
      this.$emit("clicked");
    },
  },
};
</script>
